import {createContext} from 'react';

// CREATE CONTEXT FOR USER INFORMATION FOR FIREBASE

export const UserContext = createContext({
    user: null,
    loading: null,
    error: null
});


/*export const UserSession = () => {
    const {user} = useContext(UserContext)
    return user;
}*/